export const GET_TERMINAL_LIST = 'GET_TERMINAL_LIST';
export const GET_TERMINAL_LIST_LOADING = 'GET_TERMINAL_LIST_LOADING';
